declare global {
  interface KeyboardEvent {
    isUp(): boolean;
    isDown(): boolean;
    isLeft(): boolean;
    isRight(): boolean;
    isEnter(): boolean;
    isBack(): boolean;
    isPlay(): boolean;
    isPause(): boolean;
    isPlayPause(): boolean;
    isNext(): boolean;
    isPrevious(): boolean;
    isMediaEvent(): boolean;
  }
}

export class KeyboardUtil {
  static initialize(): void {
    Object.defineProperty(KeyboardEvent.prototype, 'isUp', {
      value: function (): boolean {
        return KeyboardUtil.isUp(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isDown', {
      value: function (): boolean {
        return KeyboardUtil.isDown(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isLeft', {
      value: function (): boolean {
        return KeyboardUtil.isLeft(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isRight', {
      value: function (): boolean {
        return KeyboardUtil.isRight(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isEnter', {
      value: function (): boolean {
        return KeyboardUtil.isEnter(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isBack', {
      value: function (): boolean {
        return KeyboardUtil.isBack(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isPlay', {
      value: function (): boolean {
        return KeyboardUtil.isPlay(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isPause', {
      value: function (): boolean {
        return KeyboardUtil.isPause(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isPlayPause', {
      value: function (): boolean {
        return KeyboardUtil.isPlayPause(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isNext', {
      value: function (): boolean {
        return KeyboardUtil.isNext(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isPrevious', {
      value: function (): boolean {
        return KeyboardUtil.isPrevious(this);
      },
      writable: false,
      configurable: true,
    });

    Object.defineProperty(KeyboardEvent.prototype, 'isMediaEvent', {
      value: function (): boolean {
        return KeyboardUtil.isMediaEvent(this);
      },
      writable: false,
      configurable: true,
    });
  }

  static isLeft(event: KeyboardEvent): boolean {
    return event.key === 'ArrowLeft' || event.keyCode === 37;
  }

  static isUp(event: KeyboardEvent): boolean {
    return event.key === 'ArrowUp' || event.keyCode === 38;
  }

  static isRight(event: KeyboardEvent): boolean {
    return event.key === 'ArrowRight' || event.keyCode === 39;
  }

  static isDown(event: KeyboardEvent): boolean {
    return event.key === 'ArrowDown' || event.keyCode === 40;
  }

  static isEnter(event: KeyboardEvent): boolean {
    return (
      event.key === 'Enter' || event.keyCode === 13 || event.keyCode === 100
    );
  }

  static isBack(event: KeyboardEvent): boolean {
    return (
      event.key === 'Escape' ||
      event.key === 'Backspace' ||
      event.key === 'b' ||
      event.key === 'B' ||
      event.keyCode === 8 ||
      event.keyCode === 27 ||
      event.keyCode === 81 ||
      event.keyCode === 69 ||
      event.keyCode === 461 ||
      event.keyCode === 10009
    );
  }

  static isPlay(event: KeyboardEvent): boolean {
    return event.keyCode === 415 || event.key === 'MediaPlay';
  }

  static isPause(event: KeyboardEvent): boolean {
    return event.keyCode === 19 || event.key === 'MediaPause';
  }

  static isPlayPause(event: KeyboardEvent): boolean {
    return event.keyCode === 10252 || event.key === 'MediaPlayPause';
  }

  static isNext(event: KeyboardEvent): boolean {
    return event.keyCode === 417 || event.key === 'MediaFastForward';
  }

  static isPrevious(event: KeyboardEvent): boolean {
    return event.keyCode === 412 || event.key === 'MediaRewind';
  }

  static isMediaEvent(event: KeyboardEvent): boolean {
    return (
      event.isPlay() ||
      event.isPause() ||
      event.isPlayPause() ||
      event.isNext() ||
      event.isPrevious()
    );
  }
}
